import { css, styled } from '@compiled/react';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { absoluteFillAreaStyles } from './main';

const focusRingStyles = css({
	outline: 'none',
	'&:focus': {
		/* Atlaskit focus ring surrounds outside the element which makes it get cut off  */

		boxShadow: `
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
            inset 2px 2px ${token('color.border.focused', colors.B100)},
${/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ ''}
            inset -2px -2px ${token('color.border.focused', colors.B100)}`,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DragProxy = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
	...focusRingStyles,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TooltipTrigger = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	...absoluteFillAreaStyles,
	zIndex: 1,

	'&:focus': {
		outline: 'none',
	},
});
